module.exports = __webpack_public_path__ + "img/cerno_purple-400px.1a40d537.png";